import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import Timeline from './Timeline';
import { accountSelector } from '../../../shared/store/shared/accountSlice';
import { useGetAddendumsQuery } from './apiSlice';

function Addendums() {
  const { currentAccountId } = useSelector(accountSelector);
  const { dealId } = useParams();
  const { data } = useGetAddendumsQuery(
    {
      accountId: currentAccountId,
      dealId,
    },
    { refetchOnMountOrArgChange: true, skip: !dealId },
  );

  return data?.length > 0 ? <Timeline steps={data} /> : null;
}

export default Addendums;
